import { createReducer, on } from '@ngrx/store';
import {
  EditCustomer,
  GetCustomerDetailsSuccess,
  GetCustomerMembershipSuccess,
  GetPersonSourcesSuccess,
  ViewCustomer,
  ViewCustomerSearchPage,
} from '../actions/all-customers-summary.actions';

export interface CustomerInfoState {
  customer: any;
  searchCustomer: any;
  personSources: any[];
  customerMembership: any[];
}

const initialState: CustomerInfoState = {
  customer: null,
  searchCustomer: null,
  personSources: [],
  customerMembership: [],
};

export const CustomerInfoReducer = createReducer(
  initialState,
  on(ViewCustomer, (state, { customer }) => ({
    ...state,
    searchCustomer: customer,
  })),
  on(EditCustomer, (state, { customer }) => ({
    ...state,
    searchCustomer: customer,
  })),
  on(GetCustomerDetailsSuccess, (state, { res }) => ({
    ...state,
    customer: res,
  })),
  on(GetCustomerMembershipSuccess, (state, { res }) => ({
    ...state,
    customerMembership: res || [],
  })),
  on(GetPersonSourcesSuccess, (state, { res }) => ({
    ...state,
    personSources: res || [],
  })),
  on(ViewCustomerSearchPage, () => initialState),
);
